import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Flex } from 'reflexbox'
import { Avatar } from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'

import styles from './styles.scss'

const ApproverCard = (props) => {
  let classes = {...props.theme}
  let topClasses = `${styles.topCard} ${classes.userCard}`
  let bottomClasses = `${styles.bottomCard} ${classes.userCard}`
  let date = null

  if (props.approvalDate)
    date = (
      <span styleName='approveDate'>
        {props.approvalDate}
      </span>
    )

  return (
    <Card theme={styles}>
      <Flex class={topClasses}>
      </Flex>
      <Flex column styleName='middleCard' align='center'>
        <span styleName='userName'>
          {props.name}
        </span>
        {
          props.roles.map(role => {
            return (
              <span key={role} styleName='roleTitle'>
                { role }
              </span>
            )
          })
        }
        { date }
        <Flex auto column justify='flex-end' align='center'>
          <Flex justify='center' align='center'>
            <FontIcon styleName='emailIcon' value='email'/>
            <span styleName='emailAddress'>
              {props.email}
            </span>
          </Flex>
        </Flex>
      </Flex>
      <Flex class={bottomClasses} justify='center' align='center'>
        <span>
          {props.status}
        </span>
      </Flex>
      <Avatar theme={styles} image={ props.image }/>
    </Card>
  )
}

ApproverCard.propTypes = {
  className: PropTypes.object,
  action: PropTypes.string,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  status: PropTypes.string
}

export default CSSModules(ApproverCard, styles)
